import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { BNav, BNavItem } from "bootstrap-vue";
import historiesGridConfig from "@/components/Grid/configs/histories";
import historiesPublishedGridConfig from "@/components/Grid/configs/historiesPublished";
import historiesSharedGridConfig from "@/components/Grid/configs/historiesShared";
import { useUserStore } from "@/stores/userStore";
import Heading from "@/components/Common/Heading.vue";
import LoginRequired from "@/components/Common/LoginRequired.vue";
import GridList from "@/components/Grid/GridList.vue";
import HistoryArchive from "@/components/History/Archiving/HistoryArchive.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'GridHistory',
    props: {
        activeList: { default: "my" },
        username: { default: undefined }
    },
    setup(__props) {
        const props = __props;
        const userStore = useUserStore();
        library.add(faPlus);
        return { __sfc: true, userStore, props, faPlus, BNav, BNavItem, historiesGridConfig, historiesPublishedGridConfig, historiesSharedGridConfig, Heading, LoginRequired, GridList, HistoryArchive };
    }
});
